module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articles.length === 0 && !_vm.net_error),
      expression: "articles.length === 0 && !net_error"
    }],
    staticClass: "spinner"
  }), _vm._v(" "), _c('ul', {
    staticClass: "article-list"
  }, _vm._l((_vm.articles), function(article) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": 'articles/' + article.number.toString()
      }
    }, [_c('h2', [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
      staticClass: "article-summary",
      domProps: {
        "innerHTML": _vm._s(article.summary)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "clearfix"
    }, [_vm._v("阅读全文 "), _c('span', {
      staticClass: "time"
    }, [_vm._v("Posted at " + _vm._s(_vm._f("formatDate")(article.created_at)))])])])], 1)
  })), _vm._v(" "), (_vm.net_error) ? _c('div', {
    staticClass: "error-tip"
  }, [_vm._v("暂时无法连接服务器，请稍后再来^_^")]) : _vm._e(), _vm._v(" "), (_vm.totalArticles) ? _c('div', [_c('pagination', {
    attrs: {
      "total": _vm.totalArticles,
      "params": _vm.params
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61461126!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePage.vue
// module id = 100
// module chunks = 3